import { Spin } from "antd";

import { FIELD_PREVIEW_DEFAULT_VALUE } from "@/components/Elements/FieldPreview/FieldPreview.constant";
import TextEllipsis from "@/components/Elements/TextEllipsis";

// Can be used to display `material` and `defect` value
const MaterialFieldPreview = ({ value, loading }) => {
  if (loading)
    return (
      <span role="status">
        <Spin size="small" />
      </span>
    );

  if (!value) return FIELD_PREVIEW_DEFAULT_VALUE;

  if (typeof value === "string") return <TextEllipsis>{value}</TextEllipsis>;

  return <TextEllipsis>{value.name}</TextEllipsis>;
};

export default MaterialFieldPreview;
